import React from "react";
import styled from "styled-components";
import { fonts, links } from "../common/mixins.js";
import PayWithCashModal from "./PayWithCashModal.jsx";
import Icon from "../common/Icon.jsx";
import Overlay from "../common/Overlay";
import useModal from "../../hooks/useModal";

const Container = styled.div`
  background-color: white;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justfy-content: space-between;
  gap: 16px;
  border: 1px solid #edf1f6;
`;

const Title = styled.div`
  ${fonts.normalTextSmallBold()};
`;
const Small = styled.div`
  ${fonts.normalTextSmall()};
  display: inline;
`;
const Link = styled.a`
    ${links.linkBrightPurple()};
    font-size:14px;
`;

const Light = styled.div`
  font-family: "pf_highway_sans_pro_lightRg";
  font-size: 14px;
  color: #696781;
  flex-shrink: 0;
`;

const PrintButton = styled.div`
  font-family: "pf_highway_sans_pro_lightRg";
  display: flex;
  cursor: pointer;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #703eff;
  gap: 8px;
  margin-top: 16px;
  width: max-content;
  &:hover {
    color: #502cb5;
    text-decoration: none;
    ${Icon} {
      background-image: url("/Site/images/icons/order-details/print_purple_hover.svg");
    }
  }
`;

const PayWithCash = ({
  paymentCode,
  expirationDate,
  culture,
  dateLocation,
  eventName,
  totalTickets,
  totalProducts,
  outstandingAmount,
}) => {
  const { isOpen, openModal, closeModal } = useModal();
  const culturePrefix = (culture || "").slice(0, 2).toLowerCase();
  const otroPayUrl = culturePrefix === "el" ? "https://www.more.com/el/physical-spots/" : "https://www.more.com/en/physical-spots/";

  return (
    <>
      <Container id="payWithCash">
        <Title>{orderdetails_resources.PayWithCash}</Title>
        <div>
          <Small>{orderdetails_resources.PaymentCodeNotForDeposit}</Small>
          &nbsp;&nbsp;
          <Small id="paymentCode" style={{ fontWeight: 600, fontSize: 16 }}>
            {paymentCode}
          </Small>
        </div>
        <div>
          <div>
            <Small>{orderdetails_resources.CanAlwaysPay}</Small>&nbsp;
            <Link href={otroPayUrl} target="_blank">OTRO Pay</Link>&nbsp;
            <Small>{orderdetails_resources.AtYourArea}</Small>
          </div>
          <Light>{orderdetails_resources.FeeForPublic}</Light>
          <PrintButton
            id="printCode"
            onClick={(e) => {
              e.preventDefault();
              openModal();
            }}
          >
            <div>{orderdetails_resources.ViewDetails}</div>
          </PrintButton>
        </div>
        {/* <PayWithCashModal open={isModalOpen} paymentCode={paymentCode} onClose={handleClose} expirationDate={expirationDate} culture={culture} dateLocation={dateLocation} eventName={eventName} totalTickets={totalTickets} totalProducts={totalProducts} outstandingAmount={outstandingAmount} />
            <PayWithCashDrawer open={isDrawerOpen} paymentCode={paymentCode} eventName={eventName} onClose={handleClose} expirationDate={expirationDate} culture={culture} dateLocation={dateLocation} outstandingAmount={outstandingAmount} /> */}
      </Container>
      <Overlay
        handleClose={closeModal}
        open={isOpen}
        id="order-details-cash-print"
        titleText={orderdetails_resources.CashPaymentDetails}
        size="sm"
      >
        <PayWithCashModal
          paymentCode={paymentCode}
          expirationDate={expirationDate}
          culture={culture}
          dateLocation={dateLocation}
          eventName={eventName}
          totalTickets={totalTickets}
          totalProducts={totalProducts}
          outstandingAmount={outstandingAmount}
          closeModal={closeModal}
        />
      </Overlay>
    </>
  );
};

export default PayWithCash;
